import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { AiMappingController } from "../useAiMappingController";
import { compactActionSx } from "./aiMappingResultsShared";

interface AiMappingResultsHeaderProps {
  controller: AiMappingController;
  areaId: string;
  taskRunning: boolean;
}

export default function AiMappingResultsHeader({
  controller,
  areaId,
  taskRunning,
}: AiMappingResultsHeaderProps) {
  const hasResults =
    (controller.results?.detections?.length ?? 0) > 0 ||
    (controller.results?.segmentations?.length ?? 0) > 0;

  const runWithConfirm = (message: string, run: () => void) => {
    if (hasResults && !window.confirm(message)) return;
    run();
  };

  return (
    <MDBox p={1} sx={{ border: "1px solid #e7ebf0", borderRadius: "14px", bgcolor: "#fff" }}>
      <MDBox display="flex" gap={0.75} flexWrap="wrap" mt={1}>
        <MDButton
          color="info"
          variant="outlined"
          size="small"
          disabled={controller.busy || !!controller.activeTask}
          onClick={() =>
            runWithConfirm(
              "Are you sure you want to recount the area? Doing so will erase any manual changes you've made to the counts.",
              () => controller.detectArea(areaId)
            )
          }
          startIcon={<PlayArrowIcon />}
          data-testid="ai-mapping-detect-again"
          sx={compactActionSx}
        >
          {taskRunning && controller.activeTask?.kind === "detect" ? "Counting…" : "Count Items"}
        </MDButton>
        <MDButton
          color="info"
          variant="outlined"
          size="small"
          disabled={controller.busy || !!controller.activeTask}
          onClick={() =>
            runWithConfirm(
              "Are you sure you want to remeasure the area? Doing so will erase any manual changes you made to the measurements.",
              () => controller.segmentArea(areaId)
            )
          }
          data-testid="ai-mapping-segment"
          sx={compactActionSx}
        >
          Measure Areas
        </MDButton>
        <MDButton
          color="info"
          variant="outlined"
          size="small"
          disabled={controller.busy || !!controller.activeTask}
          onClick={() => controller.exportPdf(areaId)}
          startIcon={<PictureAsPdfIcon />}
          data-testid="ai-mapping-export-pdf"
          sx={compactActionSx}
        >
          PDF
        </MDButton>
      </MDBox>
    </MDBox>
  );
}
